export default __webpack_public_path__ + "static/media/26ff3da5ffa6f9c5.34312f4eb2a1bb2eb829eba886092b93.svg";